import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=5d2ec165&"
import script from "./Frame.ts?vue&type=script&lang=ts&"
export * from "./Frame.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports